import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IMerchantAttachment } from '@/shared/model/merchant-attachment.model';

const baseApiUrl = 'api/merchant-attachments';
const baseSearchApiUrl = 'api/_search/merchant-attachments?query=';

export default class MerchantAttachmentService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IMerchantAttachment> {
    return new Promise<IMerchantAttachment>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IMerchantAttachment): Promise<IMerchantAttachment> {
    return new Promise<IMerchantAttachment>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IMerchantAttachment): Promise<IMerchantAttachment> {
    return new Promise<IMerchantAttachment>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
